<div *ngIf="!notificationService.syncEnabled" class="p-d-flex p-flex-column p-jc-center">
	<div class="p-text-bold p-text-center">Notifications currently disabled</div>
	<button pButton type="button" label="Click Here to Enable" class="p-button-link" (click)="notificationService.enableSync()"></button>
</div>
<div *ngIf="notificationService.syncEnabled && !notifications?.length" id="no-notifications" class="p-text-center">
	Notifications will appear here as they arrive.
</div>
<div *ngIf="notificationService.syncEnabled && notifications?.length" class="p-table-container" (keydown.arrowdown)="next()" (keydown.arrowup)="previous()">
	<p-table #table
		Infinite-Table
		(onInfiniteLoad)="!notificationService.isAtEnd && !isLoading && notificationService.incrementPage()"
		[value]="notifications"
		styleClass="p-datatable-sm p-datatable-striped"
		[rowHover]="true"
		[scrollable]="true"
		scrollHeight="flex"
		selectionMode="single"
		dataKey="id"
		[(selection)]="selectedNotification">

		<ng-template pTemplate="header">
			<tr [ngClass]="notificationService.unreadCount > 0 ? 'pointer' : 'disabled'" (click)="notificationService.markAllNotificationsSeen()">
				<th colspan="2" id="mark-all-read" class="p-text-center"><i class="pi pi-bell"></i> Mark all read</th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-notification let-rowIndex="rowIndex">
			<tr [pSelectableRow]="notification" (click)="selectedNotification = notification">
				<td class="bell-col"
					(click)="$event.stopPropagation(); !notification.seen ? markRead(notification) : selectedNotification = notification"
					title="Mark Read">
					<i *ngIf="!notification.seen" class="pi pi-bell"></i>
				</td>
				<td>
					<h5 class="subject">{{notification.subject}}</h5>
					<div class="p-d-flex p-jc-between p-ai-center">
						<span>{{notification.logName}}</span>
						<span>{{notification.created | date:'MM/dd/yyyy HH:mm'}}</span>
					</div>
				</td>
			</tr>

			<!-- Loading indicator at bottom of notifications table -->
			<tr *ngIf="rowIndex === notifications.length - 1">
				<td *ngIf="!notificationService.isAtEnd && !isLoading" class="p-text-center pointer" colspan="2" (click)="$event.stopPropagation(); notificationService.incrementPage()">
					<i class="pi pi-refresh"></i> Load More
				</td>

				<td *ngIf="notificationService.isAtEnd || isLoading" colspan="2" class="p-text-center">
					<span *ngIf="isLoading && !notificationService.isAtEnd">
						<i class="pi pi-spin pi-cog"></i> Loading
					</span>

					<span *ngIf="notificationService.isAtEnd && !isLoading">
						No More Notifications
					</span>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>